import React, { useRef, useState, useEffect } from 'react'
import Api from '../../../../../_helpers/Api'
import axios from 'axios'
import Skeleton from 'react-loading-skeleton'
import Options from './AddressOptions'
import NoDataFound from '../../../../partials/NoDataFound'
import { useHistory, useLocation } from 'react-router-dom'
import Pagination from '../../../../Pagination'
import Question from '../../../../modals/messages/Question'
import { trans } from '../../../../../_providers/Translation'
import AddOrEdit from './modals/Address'

function Addresses(props) {

    const history = useHistory()
    const location = useLocation()

    const modalAddOrEditRef = useRef(null)
    const modalQuestionRef = useRef(null)
    const searchTimeoutRef = useRef(null)

    const searchParams = new URLSearchParams(location.search)
    const cancelTokenRef = useRef(null)

    const [addresses, setAddresses] = useState({
        loading: true,
        data: [],
        total: 0,
        pages: 0,
        page: 1,
        refresh: null,
        filters: {
            name: '',
        },
        setFilter: false,
        update: false,
    })


    useEffect(() => {
        setAddresses(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                name: searchParams.get('name') || '',
            },
            update: new Date().getTime()
        }))
    }, [location.search])


    useEffect(() => {
        if (addresses.setFilter) {
            searchParams.set('page', addresses.page)

            Object.entries(addresses.filters).map(filter => {
                searchParams.set(filter[0], filter[1])
            })

            history.push('?' + searchParams.toString())
        }
    }, [addresses.setFilter])

    useEffect(() => {
        if (addresses.update) {
            loadAddresses()
        }
    }, [addresses.page, addresses.refresh, addresses.update])

    const loadAddresses = () => {
        // Cancel previous request if running
        if (cancelTokenRef.current) {
            cancelTokenRef.current.cancel('Operation canceled due to new request.')
        }
        cancelTokenRef.current = axios.CancelToken.source()

        setAddresses(prev => ({
            ...prev,
            loading: true
        }))

        let url = `addresses/all?page=${addresses.page}&name=${addresses.filters.name}`

        Api.get(url, { cancelToken: cancelTokenRef.current.token })
            .then(res => {
                setAddresses(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data.items,
                    total: res.data.total,
                    pages: res.data.pages,
                }))

                if (res.data.pages > 0 && addresses.page > res.data.pages) {
                    refresh()
                }

            }).catch(err => {
                if (!axios.isCancel(err)) {
                    setAddresses(prev => ({
                        ...prev,
                        loading: false
                    }))
                }
            })
    }

    // create
    const handleAdd = () => {
        modalAddOrEditRef.current.add()
    }

    const handleCreate = address => {
        refresh(1)

        if (typeof props.handleRefresh === 'function') {
            props.handleRefresh()
        }
    }

    // update
    const handleEdit = id => {
        modalAddOrEditRef.current.edit(id)
    }

    const handleUpdate = address => {

        let data = addresses.data.map(i => {
            if (i.id == address.id) i = address
            return i
        })

        setAddresses(prev => ({
            ...prev,
            data: data
        }))

    }

    // delete
    const handleDelete = id => {
        let modal = modalQuestionRef.current

        modal.open()

        modal.onSuccess(() => {
            handleDestroy(id)
        })
    }

    const handleDestroy = id => {
        Api.post('addresses/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                refresh()

                if (typeof props.handleRefresh === 'function') {
                    props.handleRefresh()
                }
            }
        })
    }

    const handlePage = page => {
        setAddresses(prev => ({
            ...prev,
            page: page.selected + 1,
        }))
    }

    const refresh = (page) => {
        setAddresses(prev => ({
            ...prev,
            page: page || prev.page,
            refresh: new Date().getTime()
        }))
    }

    function handleSearch(name, value) {
        clearTimeout(searchTimeoutRef.current)

        setAddresses(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                [name]: value
            },
        }))

        searchTimeoutRef.current = setTimeout(() => {
            setAddresses(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }

    return (
        <div style={{ width: '100%' }}>
            <AddOrEdit
                ref={modalAddOrEditRef}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
            />

            <Question
                ref={modalQuestionRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />

            <div className="head">
                <h3
                    style={{
                        marginBottom: 0
                    }}
                >{trans('headings.addresses')}</h3>

                <button
                    className="button button-add button-small"
                    onClick={handleAdd}
                >
                    {trans('buttons.add')}
                </button>
            </div>
            <div className='filter-standard'>
                <div className="col">
                    <input
                        type="search"
                        name="name"
                        onChange={(e) => handleSearch(e.target.name, e.target.value)}
                        value={addresses.filters.name}
                        placeholder={trans('labels.search')}
                    />
                </div>
            </div>
            <hr />

            {addresses.loading
                ?
                <Skeleton height={35} count={10} />
                :
                <>
                    {addresses.data.length === 0
                        ?
                        <NoDataFound />
                        :
                        <>

                            <div className="table-scroller">
                                <table className="settings">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '50px' }}>ID</th>
                                            {/* <th>{trans('tables.country')}</th>
                                <th>{trans('tables.region')}</th>
                                <th>{trans('tables.town')}</th>
                                <th>{trans('tables.hood')}</th>
                                <th>{trans('tables.street')}</th> */}
                                            <th>{trans('tables.name')}</th>
                                            <th>{trans('tables.postCode')}</th>
                                            <th>{trans('tables.price')}</th>
                                            <th className="options">{trans('tables.options')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {addresses.data.map(address =>
                                            <tr key={'address-' + address.id}>
                                                <td style={{ width: '50px' }}>{address.id}</td>
                                                {/* <td>{address.country}</td>
                                    <td>{address.region}</td>
                                    <td>{address.city}</td>
                                    <td>{address.neighbourhood ? address.neighbourhood : trans('tables.notSelected')}</td>
                                    <td>{address.street ? address.street : trans('tables.notSelected')}</td> */}
                                                <td>{address.name}</td>
                                                <td>{address.postcode}</td>
                                                <td>{address.price ? address.price : trans('tables.notSelected')}</td>
                                                <td>
                                                    <Options
                                                        id={address.id}
                                                        handleEdit={handleEdit}
                                                        handleDelete={handleDelete}
                                                    />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <Pagination
                                pages={addresses.pages}
                                page={addresses.page}
                                handlePage={handlePage}
                            />

                        </>
                    }
                </>
            }
        </div>
    )

}

export default Addresses